import React, { useEffect, useState, useRef} from "react";
import Navbar from "../components/common/Navbar";
import Breadcrumb from "../components/common/Breadcrumb";
import Footer from "../components/other/Footer";
import ServiceCategory from "../components/services/widgets/ServiceCategory";
import BlogDetailsContent from "../components/blog/BlogDetailsContent";
import SectionsTitle from "../components/common/SectionsTitle";
import { useLocation } from "react-router-dom";
// import { useQuary } from "react-router-dom";
import Chart from "chart.js/auto"
import { Bar } from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import { toast, ToastContainer } from "react-toastify";
import GetInTouchButton from "../components/about/GetInTouchButton";

import { CustomSegmentLabelPosition } from 'react-d3-speedometer'
function InvestmentApproaches() {
  const [isMobile, setIsMobile] = useState(() => {
    const zoomLevel = window.outerWidth / window.innerWidth;
    return window.innerWidth <= 768 || zoomLevel > 1.05;
  });

  useEffect(() => {
    const checkMobile = () => {
      const zoomLevel = window.outerWidth / window.innerWidth;
      const isSmallScreen = window.innerWidth <= 768;
      const isZoomedIn = zoomLevel > 1.05;
      setIsMobile(isSmallScreen || isZoomedIn);
    };

    window.addEventListener('resize', checkMobile);
    window.addEventListener('orientationchange', checkMobile);
    return () => {
      window.removeEventListener('resize', checkMobile);
      window.removeEventListener('orientationchange', checkMobile);
    };
  }, []);
  const lists = [
    {
      id: "0",
      title: " Momentum",
      blog: {
        title: " Agreya Momentum",
        author: "Fund Manager: Arjun Narsipur",
        benchmark: "Benchmark: NIFTY 50 TRI",
        content:
          "The objective of the Investment Approach (IA) is to generate capital appreciation through investments in equities with a long term outlook. The IA aims to generate better risk-adjusted returns compared to the benchmark by investing in mega, large and large-mid cap equities with strong momentum with a technical overlay determining buy-sell decisions for investments and exits.",
      },
    },
    {
      id: "1",
      title: "Total Return ",
      blog: {
        title: "Agreya Total Return ",
        author: "Fund Manager: Shailendra Agarwal",
        benchmark:"Benchmark: S&P BSE 500 TRI",
        content:
          "The objective of the Investment Approach (IA) is to generate high capital appreciation through a curated basket of multi cap equity investments with patient long-term orientation. The IA seeks to deliver absolute long-term outperformance over the benchmark.",

      },
    },
    {
      id: "2",
      title: "Multi-Asset ",
      blog: {
        title: "Agreya Multi-Asset",
        author:
          "Fund Manager: Arjun Narsipur & Shailendra Agarwal",
          benchmark:"Benchmark: NSE Multi Asset Index 1",
          content:
          "The objective of the Investment Approach (IA) is to generate moderate returns through investments in select equity, debt and quasi debt instruments curated through Agreyaâ€™s proprietary process. The underlying investments in the IA is across permissible securities and customized to suit each investor's specific needs.",
      },
    },
    {
      id: "3",
      title: "Momentum Enhancer ",
      blog: {
        title: "Agreya Momentum Enhancer",
        author:
          "Fund Manager: Arjun Narsipur",
          benchmark:"Benchmark:NIFTY 50 TRI",
          content:
        "The objective of the Investment Approach (IA) is to generate enhanced risk- adjusted returns by investing the majority (~90%) of the capital in Agreya Momentum and the rest (~10%) is invested in derivatives to captureÂ short term trends in equity indices. The IA avoids blow out risks by only buying options."
      },
    },
    {
      id: "4",
      title: "Total Return Enhancer",
      blog: {
        title: " Agreya Total Return Enhancer",
        author:
          "Fund Manager:Shailendra Agarwal & Arjun Narsipur",
          benchmark:"Benchmark: S&P BSE 500 TRI",
          content:
          "The objective of the Investment Approach (IA) is to generate enhanced absolute returns by investing the majority (~90%) of the capital in Agreya Total Returns and the rest (~10%) is invested in derivatives to captureÂ short term trends in equity indices. The IA avoids blow out risks by only buying options.",
      },
    },
    {
      id: "5",
      title: "Multi-Asset Enhancer ",
      blog: {
        title: "Agreya Multi-Asset Enhancer ",
        author:
          "Fund Manager: Arjun Narsipur & Shailendra Agarwal",
          benchmark:"Benchmark:NSE Multi Asset Index 1",
          content:
          "The objective of the Investment Approach (IA) is to provide enhanced returns by investing the majority (90%) of the capital in Agreya Multi-Asset and the rest (~10%) is invested in derivatives to capture short term trends in equity indices. The IA avoids blow out risks by only buying options.",
      },
    },
    {
      id: "6",
      title: "Portfolio Return Optimiser",
      blog: {
        title: " Agreya Portfolio Return Optimiser",
        author:
          "Fund Manager: Arjun Narsipur",
          benchmark:"Benchmark: NSE Multi Asset Index 1",
          content:
          "The objective of the Investment Approach (IA) is to enhance the returns of underlying equity and debt holdings already held by the investor and use a small portion (~10%) of the capital in derivatives to capture short term trends in equity indices.Â The IA avoids blow out risks by only buying options.",
      },
    },
    {
      id: "7",
      title: "Value Momentum Strategy",
      blog: {
        title: "Agreya Value Momentum Strategy",
        author: "Fund Manager: Shailendra Agarwal & Arjun Narsipur",
        benchmark: "Benchmark: S&P BSE 500 TRI",
        content:
          "The primary objective of the Investment Approach is to generate high rate of capital appreciation by timing our entry and exits over a universe of value stocks within the universe.",
      },
    },
  ];
  const approachChartData = {
    "Momentum": {
      labels: ['1M', '3M', '6M', '1Y', '2Y', '3Y', '4Y', '5Y', 'SI'],
      datasets: [

        {
          label: 'Agreya Momentum',
          backgroundColor: '#033132',
          borderWidth: 0,
          borderColor: 'transparent',
          barThickness: isMobile? 15: 30,
          categoryPercentage: 4,
          data: [2.01,-1.22,-6.39,-0.30,-6.67,8.15,10.14,6.89,10.58],
        },
        {
          label: 'NIFTY 50 TRI',
          backgroundColor: '#9D7B2D',
          borderWidth: 0,
          borderColor: 'transparent',
          barThickness: isMobile? 15: 30,
          data: [-1.14,2.89,-3.60,-0.35,-1.19,9.00,9.13,8.32,10.77],
        },
      ],
    },
    "Total Return": {
      labels: ['1M', '3M', '6M', '1Y', '2Y', '3Y', '4Y', '5Y','SI'],
      datasets: [
        {
          label: 'Agreya Total Return',
          backgroundColor: '#033132',
          borderWidth: 0,
          borderColor: 'transparent',
          barThickness: isMobile? 15: 30,
          data: [3.12,7.44,25.21,31.42,8.46,15.93,17.80,14.23,21.02],
        },
        {
          label: 'S&P BSE-500 TRI',
          backgroundColor: '#9D7B2D',
          borderWidth: 0,
          borderColor: 'transparent',
          barThickness: isMobile? 15: 30,
          data: [-0.09,3.86,1.43,4.72,-0.11,12.09,11.90,10.91,12.91],
        },
      ],
    },
    "Multi-Asset Enhancer": {
      labels: ['1M', '3M', '6M', '1Y', '2Y', '3Y', '4Y','5Y','SI' ],
      datasets: [
        {
          label: 'Agreya Multi-Asset Enhancer',
          backgroundColor: '#033132',
          borderWidth: 0,
          borderColor: 'transparent',
          barThickness: isMobile? 10: 30,
          data: [1.18,2.50,0.72,5.79,7.11,10.15,8.82,10.22,14.21],
        },
        {
          label: 'NSE Multi Asset Index 1',
          backgroundColor: '#9D7B2D',
          borderWidth: 0,
          borderColor: 'transparent',
          barThickness: isMobile? 15: 30,
          data: [0.28,3.46,3.00,7.54,5.00,11.26,10.42,9.72,11.12],
        },
      ],
    },
    "Total Return Enhancer": {
      labels: ['1M', '3M', '6M', '1Y', '2Y','3Y','4Y','5Y','SI'],
      datasets: [
        {
          label: 'Agreya Total Return Enhancer',
          backgroundColor: '#033132',
          borderWidth: 0,
          borderColor: 'transparent',
          barThickness: isMobile? 15: 30,
          data: [2.70,5.44,17.00,20.76,5.51,14.90,15.88,14.17,16.28],
        },
        {
          label: 'S&P BSE 500 TRI',
          backgroundColor: '#9D7B2D',
          borderWidth: 0,
          borderColor: 'transparent',
          barThickness: isMobile? 15: 30,
          data: [-0.09,3.86,1.43,4.72,-0.11,12.09,11.90,10.91,13.17],
        },
      ],
    },
    "Portfolio Return Optimiser": {
      labels: ['1M', '3M', '6M', '1Y','2Y','3Y','4Y','SI'],
      datasets: [
        {
          label: 'Agreya Portfolio Return Optimiser',
          backgroundColor: '#033132',
          borderWidth: 0,
          borderColor: 'transparent',
          barThickness: isMobile? 15: 30,
          data: [2.33,1.39,-1.18,9.84,5.89,7.16,11.01,11.34],
        },
        {
          label: 'NSE Multi Asset Index 1',
          backgroundColor: '#9D7B2D',
          borderWidth: 0,
          borderColor: 'transparent',
          barThickness: isMobile? 15: 30,
          data: [0.28,3.46,3.00,7.54,5.00,11.26,10.42,10.68],
        },
      ],
    },
    "Multi-Asset": {
      labels:  ['1M', '3M', '6M', '1Y', '2Y', '3Y','4Y','5Y','SI'],
      datasets: [
        {
          label: 'Agreya Multi-Asset',
          backgroundColor: '#033132',
          borderWidth: 0,
          borderColor: 'transparent',
          barThickness: isMobile? 15: 30,
          data: [0.91,3.71,3.13,8.36,7.02,9.99,9.84,9.05,9.77],
        },
        {
          label: 'NSE Multi Asset Index 1',
          backgroundColor: '#9D7B2D',
          borderWidth: 0,
          borderColor: 'transparent',
          barThickness: isMobile? 15: 30,
          data: [0.28,3.46,3.00,7.54,5.00,11.26,10.42,9.72,11.46],
        },
      ],
    },
    "Momentum Enhancer": {
      labels: ['1M', '3M', '6M','1Y','2Y','3Y','SI'],
      datasets: [
        {
          label: 'Agreya Momentum Enhancer',
          backgroundColor: '#033132',
          borderWidth: 0,
          borderColor: 'transparent',
          barThickness: isMobile? 15: 30,
          data: [1.44,-0.51,-8.53,-1.54,-4.49,11.20,15.04],
        },
        {
          label: 'Nifty 50 TRI',
          backgroundColor: '#9D7B2D',
          borderWidth: 0,
          borderColor: 'transparent',
          barThickness: isMobile? 15: 30,
          data: [-1.14,2.89,-3.60,-0.35,-1.19,9.00,11.13],
        },
      ],
    },
    "Value Momentum Strategy": {
      labels: ['1M', '3M', '6M', '1Y', 'SI'],
      datasets: [
        {
          label: 'Agreya Value Momentum Strategy',
          backgroundColor: '#033132',
          borderWidth: 0,
          borderColor: 'transparent',
          barThickness: isMobile ? 15 : 30,
          data: [0.27,3.27,18.80,19.84,18.02],
        },
        {
          label: 'S&P BSE 500 TRI',
          backgroundColor: '#9D7B2D',
          borderWidth: 0,
          borderColor: 'transparent',
          barThickness: isMobile ? 15 : 30,
          data: [-0.09,3.86,1.43,4.72,9.01],
        },
      ],
    },
  };

  const [blog, setBlog] = React.useState(lists[0].blog);
  const [barChartData, setBarChartData] = React.useState(approachChartData[lists[0].title] || {});
  // const [speedometerValue, setSpeedometerValue] = React.useState(0);
  const [speedometerValue, setSpeedometerValue] = React.useState(0);
  const chartContainerRef = useRef(null);
  const barChartRef = useRef(null);
  const [hiddenDatasets, setHiddenDatasets] = useState({});


  const riskLevelValues = {
    "Very High Risk": 900,
    "Moderately High risk": 500,
    "High risk": 700,
  };

  const riskLevelNames = {
    " Agreya Momentum": "High risk",
    "Agreya Total Return ": "Very High Risk",
    "Agreya Multi-Asset Enhancer ": "High risk",
    " Agreya Total Return Enhancer": "Very High Risk",
    " Agreya Portfolio Return Optimiser": "Very High Risk",
    "Agreya Multi-Asset": "Moderately High risk",
    "Agreya Momentum Enhancer": "Very High Risk",
    "Agreya Value Momentum Strategy": "High risk",
  };

  const updateChartAndSpeedometerData = (blogData) => {
    const selectedApproachTitle = lists.find(list => list.blog.title === blogData.title)?.title.trim();
    const selectedChartData = approachChartData[selectedApproachTitle];
    if (selectedChartData && Array.isArray(selectedChartData.labels) && Array.isArray(selectedChartData.datasets)) {
      setBarChartData(selectedChartData);
    } else {
      setBarChartData({});
    }
    setSpeedometerValue(riskLevelValues[riskLevelNames[blogData.title]] || 0);
  };

  const updateBlog = (blog) => {
    setBlog(blog);
    updateChartAndSpeedometerData(blog);
  };

  const announceChartHelp = () => {
    toast.info(`Chart data: ${blog.title.trim()} vs ${getBenchmarkName(blog.benchmark)}. Use the legend buttons below to show or hide each data series.`, {
      toastId: 'chart-keyboard-help',
    });
  };
  const { search } = useLocation();
  const useQuery = () => {
    return React.useMemo(() => new URLSearchParams(search), [search]);
  };
  let query = useQuery();

  useEffect(() => {
    document.title = "Investment Approaches - Agreya Capital";
  }, []);

  useEffect(() => {
    const number = parseInt(query.get("name")) || 0;
    if (!isNaN(number) && lists[number]) {
      const selectedBlog = lists[number].blog;
      setBlog(selectedBlog);
      updateChartAndSpeedometerData(selectedBlog);
    }
  }, [query]);

  useEffect(() => {
    setHiddenDatasets({});

    const chart = barChartRef.current;

    if (chart?.data?.datasets) {
      chart.data.datasets.forEach((dataset, index) => {
        chart.setDatasetVisibility(index, true);
      });
      chart.update();
    }
  }, [barChartData]);

  const getBenchmarkName = (benchmarkText) => {
    if (benchmarkText) {
      return benchmarkText.replace("Benchmark: ", "").trim();
    }
    return "";
  };

  const chartAriaLabel = `Bar chart comparing ${blog.title.trim()} and ${getBenchmarkName(blog.benchmark)} returns across different time periods`;

  useEffect(() => {
    const chart = barChartRef.current;
    const canvas = chart?.canvas;

    if (!canvas) {
      return undefined;
    }

    const handleCanvasKeyDown = (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        announceChartHelp();
      }
    };

    const handleCanvasFocus = () => {
      canvas.style.boxShadow = '0 0 0 3px #9D7B2D';
      canvas.style.borderRadius = '4px';
    };

    const handleCanvasBlur = () => {
      canvas.style.boxShadow = 'none';
    };

    canvas.setAttribute('tabindex', '0');
    canvas.setAttribute('role', 'img');
    canvas.setAttribute('aria-label', chartAriaLabel);
    canvas.style.outline = 'none';

    canvas.addEventListener('keydown', handleCanvasKeyDown);
    canvas.addEventListener('focus', handleCanvasFocus);
    canvas.addEventListener('blur', handleCanvasBlur);

    return () => {
      canvas.removeEventListener('keydown', handleCanvasKeyDown);
      canvas.removeEventListener('focus', handleCanvasFocus);
      canvas.removeEventListener('blur', handleCanvasBlur);
    };
  }, [chartAriaLabel, blog.title, blog.benchmark, barChartData]);

  const toggleDatasetVisibility = (datasetIndex) => {
    const chart = barChartRef.current;

    if (!chart) {
      return;
    }

    const nextVisible = !chart.isDatasetVisible(datasetIndex);
    chart.setDatasetVisibility(datasetIndex, nextVisible);
    chart.update();
    setHiddenDatasets((currentState) => ({
      ...currentState,
      [datasetIndex]: !nextVisible,
    }));
  };

  const barChartOptions = {


  animation: {
    duration: 4000,
  },
  layout: {
    padding: {
      padding: 20
  }
},
 scales: {
      x: {
        grid: {
          display: false,
        },
        offset: true,
        barPercentage: 4

      },
      y: {
        grid: {
          display: false,
        },
        offset: true,
        barPercentage: 6,
        ticks: {
          callback: (value, index, values) => {
            return `${value}%`;
          },
          stepSize: 10,
        },
      },

    },
    plugins: {
      tooltip: {
        enabled: true,
        backgroundColor: '#333',
        titleColor: '#fff',
        bodyColor: '#fff',
        padding: 8,
        displayColors: true,
        borderColor: '#666',
        borderWidth: 1,
        callbacks: {
          label: function(context) {
            const label = context.dataset.label || '';
            const value = context.parsed.y;
            return `${label}: ${value}%`;
          }
        }
      },
      legend: {
        display: false,
        position: 'bottom',
        labels: {
          usePointStyle: true,
          padding: 15,
          font: {
            size: 12,
            weight: 'bold',
          },
          boxWidth: 20,
          boxHeight: 20,
          color: '#333',
        },
      },
      datalabels: {
        anchor: 'end',
        align: 'end',
        display: true,
        color: 'black',
        font: {
          size: isMobile ? 5 : 10,
          weight: 'bold',
        },
        formatter: (value, context) => {
          return `${value}%`;
        },
        maxWidth: 1,
      },
    },
    // suggestedMin: 0, // Set the minimum value on the y-axis
    // suggestedMax: 40,
    maintainAspectRatio: false,
  };
  const customSegmentLabels = [
    {
      text: "Low",
      position: CustomSegmentLabelPosition.Inside ,
      color: "#FFFFFF",
      fontSize: "8px",

    },

    {
      text: "Moderate",
      position: CustomSegmentLabelPosition.Inside ,
      color: "#1F2D00",
      fontSize: "8px",
    },
    {
      text: "Moderately High",
      position:CustomSegmentLabelPosition.Inside ,
      color: "#FFFFFF",
      fontSize: "8px",
    },
    {
      text: "High",
      position: CustomSegmentLabelPosition.Inside ,
      color: "#000000",
      fontSize: "8px",
    },
    {
      text: "Very High",
      position: CustomSegmentLabelPosition.Inside ,
      color: "#FFFFFF",
      fontSize: "8px",
    },


  ];
  const segmentColors = ["#25482C", "#8D9749", "#3C200B", "#987D4B", "#651208"];


const DisclaimerText = 'The above returns are not verified by SEBI.For relative performance comparisons against other Portfolio Managers within this strategy, please visit the APMI Website ';
// const PerformanceText = `Performance as of Mar'24`;
  let date="August 31, 2026";

  const accessibilityPlugin = {
    id: 'accessibilityPlugin',
    afterDraw(chart) {
      const canvas = chart.canvas;
      if (canvas) {
        const ariaLabel = `Bar chart comparing ${blog.title.trim()} and ${getBenchmarkName(blog.benchmark)} returns across different time periods`;
        canvas.setAttribute('aria-label', ariaLabel);
        canvas.setAttribute('role', 'img');
        canvas.setAttribute('tabindex', '0');
      }
    }
  };

  const sinceInceptionTexts = {
    "Agreya Momentum": `As of ${date}  \u00A0  \u00A0 Since Inception (SI) Date: 31/08/2018`,
    "Agreya Total Return": `As of ${date}  \u00A0  \u00A0 Since Inception (SI) Date: 14/09/2018`,
    "Agreya Multi-Asset Enhancer": `As of ${date}  \u00A0  \u00A0 Since Inception (SI) Date: 04/06/2019`,
    "Agreya Total Return Enhancer": `As of ${date}  \u00A0  \u00A0 Since Inception (SI) Date: 22/02/2021`,
    "Agreya Portfolio Return Optimiser": `As of ${date}  \u00A0  \u00A0 Since Inception (SI) Date: 16/03/2022`,
    "Agreya Multi-Asset": `As of ${date}  \u00A0 \u00A0 Since Inception (SI) Date: 02/03/2019`,
    "Agreya Momentum Enhancer": `As of ${date}  \u00A0   \u00A0Since Inception (SI) Date: 11/03/2023`,
    "Agreya Value Momentum Strategy": `As of ${date}  \u00A0  \u00A0 Since Inception (SI) Date: 20/03/2025`,
  };

  // const isMobile = window.innerWidth <= 768;
  // {console.log("cxcxsMobile:", isMobile)}
  return (
    <>
      <header className="header-area">
        <Navbar />
        <ToastContainer />
        <div className="get-in-touch-container">
          <GetInTouchButton />
        </div>
      </header>
      <main id="main-content">
      <div className="con" style={{ marginTop: "100px", overflow: "auto" }}>
        <div className="inv" style={{ display: isMobile ? "flex-column" : "flex", flexDirection: isMobile ? "column" : "row", maxWidth: "100%", paddingTop: "-10px", overflow: "auto" }}>
          <div style={{ maxWidth: isMobile ? "100%" : "250px", margin: isMobile ? "20px 0" : "30px 20px 0 50px", width: isMobile ? "100%" : "auto" }}>
            <ServiceCategory lists={lists} updateBlog={updateBlog} currentItemId={lists.find(item => item.blog.title === blog.title)?.id} />
          </div>
          <div style={{ width: isMobile ? "100%" : "100%", marginTop: isMobile ? "0px" : "-50px", marginLeft: isMobile ? "0" : "2px", marginBottom: "20px", overflow: "auto" }}>
            <BlogDetailsContent blog={blog} speedometerValue={speedometerValue} customSegmentLabels={customSegmentLabels} segmentColors={segmentColors} isMobile={isMobile}/>
            {/* <div style={{ overflowX: "auto", width: "100%",height: "100%" }}> */}
              <div
                ref={chartContainerRef}
                className="bar"
                role="group"
                aria-label={`${chartAriaLabel}. Use the chart canvas and legend buttons below for keyboard access.`}
                style={{
                  overflowX: "auto",
                  width: isMobile ? "100%" : "68%",
                  height:isMobile?"500px": "320px",
                  justifyContent: "center",
                  display: "flex",
                  marginTop: "-70px",
                  marginLeft: isMobile ? "0" : "15%",
                  position: "relative"
                }}
              >
                {barChartData && barChartData.datasets ? (
                  <>
                    <Bar ref={barChartRef} data={barChartData} options={barChartOptions} plugins={[ChartDataLabels, accessibilityPlugin]} />
                  </>
                ) : (
                  <p>Loading chart data...</p>
                )}
              </div>
              {barChartData && barChartData.datasets ? (
                <div
                  aria-label="Chart legend controls"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "12px",
                    flexWrap: "wrap",
                    marginTop: "12px",
                    marginBottom: "8px",
                  }}
                >
                  {barChartData.datasets.map((dataset, index) => {
                    const isPressed = !hiddenDatasets[index];

                    return (
                      <button
                        key={dataset.label}
                        type="button"
                        role="button"
                        aria-label={dataset.label}
                        aria-pressed={isPressed}
                        onClick={() => toggleDatasetVisibility(index)}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "8px",
                          border: "1px solid #677286",
                          borderRadius: "999px",
                          padding: "8px 14px",
                          backgroundColor: isPressed ? "#ffffff" : "#f2f2f2",
                          color: "#033132",
                          cursor: "pointer",
                          fontSize: "12px",
                          fontWeight: 700,
                          textDecoration: isPressed ? "none" : "line-through",
                        }}
                        onFocus={(event) => {
                          event.currentTarget.style.outline = "2px solid #9D7B2D";
                          event.currentTarget.style.outlineOffset = "2px";
                        }}
                        onBlur={(event) => {
                          event.currentTarget.style.outline = "none";
                        }}
                      >
                        <span
                          aria-hidden="true"
                          style={{
                            width: "12px",
                            height: "12px",
                            borderRadius: "50%",
                            backgroundColor: dataset.backgroundColor,
                            opacity: isPressed ? 1 : 0.45,
                          }}
                        />
                        <span>{dataset.label}</span>
                      </button>
                    );
                  })}
                </div>
              ) : null}
            {/* </div> */}
            <div style={{ textAlign:"center", marginTop: "5px", fontSize: "12px", }}>
              <p>{sinceInceptionTexts[blog.title.trim()]}</p>
            </div>
            <div style={{textAlign:"center", marginTop: "-5px", fontSize: "9px"}}>
              <p>{DisclaimerText}<a href="https://www.apmiindia.org/apmi/welcomeiaperformance.htm?action=PMSmenu" target="_blank" rel="noopener noreferrer" style={{color: "#0d84ec", textDecoration: "none", fontWeight: "bold"}}>IA Performance</a> and <a href="https://www.apmiindia.org/vistadashboard/" target="_blank" rel="noopener noreferrer" style={{color: "#0d84ec", textDecoration: "none", fontWeight: "bold"}}>APMI Vista - PMS Insight</a></p>
            </div>
            {/* <div style={{ textAlign:isMobile?"right":"left",marginTop: isMobile ? "-500px" : "-300px", fontSize: isMobile ?"10px":"12px" }}>
              <p>{PerformanceText}</p>
            </div> */}
          </div>
        </div>
      </div>
      </main>
    </>
  );

  }
  export default InvestmentApproaches;

